import { apiMiddleware } from 'redux-api-middleware'

export const getContentLayerMiddleWare = () => {
  return apiMiddleware
}
